import {Children, Vnode, VnodeDOM} from 'mithril';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import AbstractProcessingPage from './AbstractProcessingPage';
import ErrorPage from '../components/ErrorPage';
import PageContainer from '../components/PageContainer';
import Form from '../models/Form';

export default abstract class AbstractFormPage extends AbstractProcessingPage {
    form!: Form

    oninit(vnode: Vnode) {
        super.oninit(vnode);

        const id = m.route.param('id');
        const preloadedForm = app.preloadedApiDocument<Form>();

        if (preloadedForm) {
            this.show(preloadedForm);
        } else {
            //TODO: check if form is already preloaded by slug
            const form = app.store.getById<Form>('formulaire-forms', id);

            if (form) {
                this.show(form);
            } else {
                app.store.find<Form>('formulaire/forms', id, {}, {
                    errorHandler: this.pageLoadErrorHandler.bind(this),
                }).then(form => {
                    this.show(form);
                    m.redraw();
                });
            }
        }
    }

    onremove(vnode: VnodeDOM) {
        super.onremove(vnode);

        delete document.body.dataset.formulaireFormId;
    }

    show(form: Form) {
        this.form = form;

        // This data attribute isn't used by Formulaire, but is useful for user customization
        document.body.dataset.formulaireFormId = form.id();
    }

    view(): Children {
        if (this.errorPage) {
            return m(PageContainer, m(ErrorPage, {
                error: this.errorPage,
            }));
        }

        if (!this.form) {
            return m('.container', LoadingIndicator.component({className: 'LoadingIndicator--block'}));
        }

        return this.content(this.form);
    }

    abstract content(form: Form): Children
}
